var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentForDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 0.0) scale(0.521739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H38C42.4183 0 46 3.58172 46 8V38C46 42.4183 42.4183 46 38 46H8C3.58172 46 0 42.4183 0 38V8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8877 21.8967C30.2827 21.7007 31.3567 20.5047 31.3597 19.0557C31.3597 17.6277 30.3187 16.4437 28.9537 16.2197",
    stroke: "currentColor",
    strokeWidth: 2.875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7285 25.25C32.0795 25.452 33.0225 25.925 33.0225 26.9C33.0225 27.571 32.5785 28.007 31.8605 28.281",
    stroke: "currentColor",
    strokeWidth: 2.875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8867 25.6641C19.6727 25.6641 16.9277 26.1511 16.9277 28.0961C16.9277 30.0401 19.6557 30.5411 22.8867 30.5411C26.1007 30.5411 28.8447 30.0591 28.8447 28.1131C28.8447 26.1671 26.1177 25.6641 22.8867 25.6641Z",
    stroke: "currentColor",
    strokeWidth: 2.875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8869 22.888C24.9959 22.888 26.7059 21.179 26.7059 19.069C26.7059 16.96 24.9959 15.25 22.8869 15.25C20.7779 15.25 19.0679 16.96 19.0679 19.069C19.0599 21.171 20.7569 22.881 22.8589 22.888H22.8869Z",
    stroke: "currentColor",
    strokeWidth: 2.875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8848 21.8967C15.4888 21.7007 14.4158 20.5047 14.4128 19.0557C14.4128 17.6277 15.4538 16.4437 16.8188 16.2197",
    stroke: "currentColor",
    strokeWidth: 2.875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.044 25.25C13.693 25.452 12.75 25.925 12.75 26.9C12.75 27.571 13.194 28.007 13.912 28.281",
    stroke: "currentColor",
    strokeWidth: 2.875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentForDocIcon);
export default __webpack_public_path__ + "static/media/studentForDocIcon.f1335cf040a3118d98680535abe07237.svg";
export { ForwardRef as ReactComponent };